import { all, select, takeEvery, fork, put } from 'redux-saga/effects'

// action
import { userActions } from '@redux/store/index'

// lib
import { Logger } from '@utils'

// type
import { UserType } from '@schemas'

function* userSaga() {
	try {
		const userLanguage: string = yield select(state => state.user.language)

		if (userLanguage === '') {
			const user: UserType = yield select(state => state.user.user)
			const newUserLanguage: string = user.language === '' ? 'KO' : user.language
			yield put(userActions.LANGUAGE(newUserLanguage))
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(userActions.USER, userSaga)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
